module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Value.js"));
	}, "Value");
}